import styled from 'styled-components';

export const Wrapper = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  
  input {
    border-top-right-radius: 0;
    border-bottom-right-radius: 0;
  }
`;